export type BayesPresetId =
  | 'medical-test'
  | 'spam-filter'
  | 'monty-hall-as-bayes'
  | 'draw-without-replacement'
  | 'coin-coin'
  | 'custom-2level'
  | 'custom-3level';

export interface BayesPreset {
  id: BayesPresetId;
  labelKey: `preset.conditional-bayes.${BayesPresetId}.label`;
  prior: number;
  sensitivity: number;
  falsePositiveRate: number;
}

export const BAYES_PRESETS: readonly BayesPreset[] = [
  {
    id: 'medical-test',
    labelKey: 'preset.conditional-bayes.medical-test.label',
    prior: 0.01,
    sensitivity: 0.95,
    falsePositiveRate: 0.05,
  },
  {
    id: 'spam-filter',
    labelKey: 'preset.conditional-bayes.spam-filter.label',
    prior: 0.4,
    sensitivity: 0.7,
    falsePositiveRate: 0.05,
  },
  {
    id: 'monty-hall-as-bayes',
    labelKey: 'preset.conditional-bayes.monty-hall-as-bayes.label',
    prior: 1 / 3,
    sensitivity: 1,
    falsePositiveRate: 0.5,
  },
  {
    id: 'draw-without-replacement',
    labelKey: 'preset.conditional-bayes.draw-without-replacement.label',
    prior: 0.4,
    sensitivity: 0.5,
    falsePositiveRate: 0.6,
  },
  {
    id: 'coin-coin',
    labelKey: 'preset.conditional-bayes.coin-coin.label',
    prior: 0.5,
    sensitivity: 0.5,
    falsePositiveRate: 0.5,
  },
  {
    id: 'custom-2level',
    labelKey: 'preset.conditional-bayes.custom-2level.label',
    prior: 0.3,
    sensitivity: 0.7,
    falsePositiveRate: 0.2,
  },
  {
    id: 'custom-3level',
    labelKey: 'preset.conditional-bayes.custom-3level.label',
    prior: 0.5,
    sensitivity: 0.6,
    falsePositiveRate: 0.3,
  },
];
